<template>
    <svg xmlns="http://www.w3.org/2000/svg" :width="width" :height="height" viewBox="0 0 22.693 23.677">
        <g id="alarm" transform="translate(-64.382)">
            <path id="Path_70128" data-name="Path 70128" d="M241,0h1.776V4.264H241Z" transform="translate(-166.164)"
                  fill="#fff"/>
            <path id="Path_70129" data-name="Path 70129" d="M0,0H4.264V1.776H0Z"
                  transform="translate(79.165 4.596) rotate(-68.156)" fill="#fff"/>
            <path id="Path_70130" data-name="Path 70130" d="M0,0H4.264V1.776H0Z"
                  transform="matrix(0.674, -0.739, 0.739, 0.674, 82.888, 6.66)" fill="#fff"/>
            <path id="Path_70131" data-name="Path 70131" d="M0,0H1.776V4.264H0Z"
                  transform="translate(69.051 1.289) rotate(-21.844)" fill="#fff"/>
            <path id="Path_70132" data-name="Path 70132" d="M0,0H1.776V4.264H0Z"
                  transform="matrix(0.739, -0.674, 0.674, 0.739, 64.382, 4.705)" fill="#fff"/>
            <path id="Path_70133" data-name="Path 70133" d="M120,364h16.1v2.131H120Z"
                  transform="translate(-52.326 -342.454)" fill="#fff"/>
            <path id="Path_70135" data-name="Path 70135"
                  d="M136.1,128.05a8.05,8.05,0,1,0-16.1,0v4.617h16.1Zm-7.162,2.386h-1.776v-1.776h1.776Zm0-3h-1.776v-4.814h1.776Z"
                  transform="translate(-52.326 -112.897)" fill="#fff"/>
        </g>
    </svg>

</template>

<script>
    export default {
        name: "IAlarm",
        props: {
            width: {
                type: String,
                default: '1.5em'
            },
            height: {
                type: String,
                default: '1.5em'
            }
        }
    }
</script>

<style scoped>

</style>
